import { TActions } from '../../../AppModulesWrapper';

import { SET_MICROFRONTEND_HOST_NAME, SET_MICROFRONTEND_INIT_LOAD_TIME } from '../../actions/microfrontend';
import { IMicrofrontendState } from '../../types/reducers/microfrontend';

import { defaultState } from './defaultState';

export const microfrontend = (state: IMicrofrontendState = defaultState, action: TActions): IMicrofrontendState => {
  switch (action.type) {
    case SET_MICROFRONTEND_HOST_NAME:
      return { ...state, hostName: action.payload };

    case SET_MICROFRONTEND_INIT_LOAD_TIME:
      return { ...state, initLoadTime: action.payload };

    default:
      return state;
  }
};
